import React, { useEffect, useState } from "react";
import { bool, func, number, oneOf, string } from "prop-types";

import NoteEditor from "../NoteEditor";
import * as S from "./styled";

const EditNote = props => {
  const [isEditorOpened, setIsEditorOpened] = useState(false);
  const [isNoteUpdated, setIsNoteUpdated] = useState(props.isNoteUpdated);

  useEffect(() => {
    setIsNoteUpdated(props.isNoteUpdated);
  }, [props.isNoteUpdated, props.text]);

  if (isNoteUpdated) {
    setTimeout(() => {
      setIsNoteUpdated(false);
    }, 2000);
  }

  return (
    <S.Container>
      <S.Header as="label" id="listing-note-text">
        Your Notes
      </S.Header>
      {!isEditorOpened && isNoteUpdated && (
        <S.SavedNotification>
          <S.CheckIcon />
          Saved!
        </S.SavedNotification>
      )}
      {isEditorOpened ? (
        <NoteEditor
          closeEditor={() => setIsEditorOpened(false)}
          type="update"
          {...props}
        />
      ) : (
        <>
          <S.EditButton onClick={() => setIsEditorOpened(true)}>
            <S.EditIcon />
            Edit
          </S.EditButton>
          <S.Note id="listing-note-text">{props.text}</S.Note>
        </>
      )}
    </S.Container>
  );
};

EditNote.propTypes = {
  isNoteUpdated: bool.isRequired,
  listing_id: number.isRequired,
  listing_type: oneOf(["sale", "rental"]).isRequired,
  setNoteText: func.isRequired,
  text: string.isRequired
};

export default EditNote;
